import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { WidgetGrid, JarvisWidget } from '../../../components';

import {
  requestActions,
  addAction,
  requestAlertLimits,
  requestVisitNote,
  requestEncounters,
  requestBullets,
  requestICDLookup,
  requestMedications,
} from '../../../store/visit-notes/VisitNotesActions';
import { requestClaimsHistory } from '../../../store/patients/PatientsActions';

import VisitView from '../components/VisitView';
import { hostTitle } from '../../../config/ui';

class VisitNote extends React.Component {
  componentWillMount() {
    const {
      params: { id },
      getNote,
      limits,
      getAlertLimits,
      actions,
      getActions,
      bullets,
      getBullets,
      lookups,
    } = this.props;

    getNote(id, this.props.currentUser.queryParams);

    if (!limits) {
      getAlertLimits();
    }

    if (!actions[id]) {
      getActions(id, this.props.currentUser.queryParams);
    }

    if (!bullets[id]) {
      getBullets(id, this.props.currentUser.queryParams);
    }

    if (!lookups.icd) {
      this.props.getICDLookup(this.props.currentUser.queryParams.tenantId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      params: { id },
      getEncounters,
      getMedications,
      getHistory,
    } = this.props;
    const {
      encounters,
      visitNote,
      isEncountersLoading,
      medications,
      isMedicationsLoading,
      history,
      isHistoryLoading,
    } = nextProps;
    if (!encounters[id] && visitNote[id] && !isEncountersLoading) {
      getEncounters(
        visitNote[id].patientID,
        id,
        this.props.currentUser.queryParams,
      );
    }
    if (visitNote[id] && !medications[id] && !isMedicationsLoading) {
      getMedications(
        id,
        visitNote[id].patientID,
        visitNote[id].dateOfService,
        this.props.currentUser.queryParams.tenantId,
      );
    }

    if (
      visitNote[id] &&
      !history[visitNote[id].patientID] &&
      !isHistoryLoading
    ) {
      getHistory(visitNote[id].patientID, {
        tenantId: this.props.currentUser.queryParams.tenantId,
        from: visitNote[id].dateOfService,
      });
    }
  }

  getActions = () => {
    const {
      params: { id },
      actions,
    } = this.props;

    return actions[id] ? actions[id] : {};
  };

  getEncounters = () => {
    const {
      params: { id },
      encounters,
    } = this.props;

    return encounters[id] ? encounters[id] : {};
  };

  getBullets = () => {
    const {
      params: { id },
      bullets,
    } = this.props;

    return bullets[id] ? bullets[id] : {};
  };

  getMedications = () => {
    const {
      params: { id },
      medications,
    } = this.props;

    return medications[id] ? medications[id] : {};
  };

  getHistory = () => {
    const {
      params: { id },
      history,
      visitNote,
    } = this.props;

    return history[visitNote[id].patientID]
      ? history[visitNote[id].patientID]
      : {};
  };

  toggleNotes = () => {
    return false;
  };

  addAction = () => {
    return false;
  };

  render() {
    const {
      visitNote,
      params: { id },
      limits,
      isNoteLoading: isLoading,
      isEncountersLoading,
      isActionsLoading,
      isBulletsLoading,
      isMedicationsLoading,
      isHistoryLoading,
      lookups,
    } = this.props;
    return (
      <div id="content">
        <Helmet title={`${id} Visit Note – ${hostTitle()}`} />
        <WidgetGrid>
          <JarvisWidget
            colorbutton={false}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
            color="white"
            fullscreenbutton={true}
          >
            <header>
              <h2>
                <strong>{id}</strong> <i>Visit Note ID</i>
              </h2>
            </header>
            <div className="visit-note-single-view">
              {isLoading && <div className="spinner" />}
              {visitNote[id] && (
                <VisitView
                  ref="VisitViewWrapper"
                  data={visitNote[id]}
                  actions={this.getActions()}
                  isActionsLoading={isActionsLoading}
                  encounters={this.getEncounters()}
                  isEncountersLoading={isEncountersLoading}
                  bullets={this.getBullets()}
                  isBulletsLoading={isBulletsLoading}
                  medications={this.getMedications()}
                  isMedicationsLoading={isMedicationsLoading}
                  limits={limits}
                  lookups={lookups}
                  showNotes={false}
                  toggleNotes={this.toggleNotes}
                  addAction={this.addAction}
                  view="VISIT_NOTE_VIEW"
                  history={this.getHistory()}
                  isHistoryLoading={isHistoryLoading}
                />
              )}
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    ...state.visitNotes,
    currentUser: state.currentUser,
    history: state.patients.history,
    isHistoryLoading: state.patients.isHistoryLoading,
  }),
  (dispatch) => ({
    getNote: (id, params) => dispatch(requestVisitNote(id, params)),
    getAlertLimits: () => dispatch(requestAlertLimits()),
    getActions: (visitNoteID, params) =>
      dispatch(requestActions(visitNoteID, params)),
    addAction: (visitNoteID, data, params) =>
      dispatch(addAction(visitNoteID, data, params)),
    getEncounters: (patientID, visitNoteID, params) =>
      dispatch(requestEncounters(patientID, visitNoteID, params)),
    getBullets: (visitNoteID, params) =>
      dispatch(requestBullets(visitNoteID, params)),
    getICDLookup: (tenantId) => dispatch(requestICDLookup(tenantId)),
    getMedications: (visitNoteID, patientID, serviceDate, tenantId) =>
      dispatch(
        requestMedications(visitNoteID, patientID, serviceDate, tenantId),
      ),
    getHistory: (patientID, params) =>
      dispatch(requestClaimsHistory(patientID, params)),
  }),
)(VisitNote);



// WEBPACK FOOTER //
// ./src/routes/management/containers/VisitNote.js